module.exports = __webpack_public_path__ + "img/organ.12897e1a.webp";